import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import NarrativeVoting from '@/pages/Narrative/components/NarrativeVoting';
import { CreateAnnouncement } from '@/pages/Narrative/components/CreateAnnouncement';
import { CommentNarrative } from '../CommentNarrative';
import { SetFairValue } from '../SetFairValue';
import { useRef } from 'react';
// import { Button } from '@simplywallst/ui-core/next';

type Props = {
  narrative: Narrative;
  onCommentClick: () => void;
};

export const NarrativeActions = ({ narrative, onCommentClick }: Props) => {
  const { id, slug, company, voteCount } = narrative;
  const containerRef = useRef<HTMLDivElement>(null);

  if (!company) return null;

  return (
    <div className="flex w-full flex-wrap justify-start gap-2">
      <SetFairValue
        companyId={company.id}
        narrativeId={id}
        containerRef={containerRef}
        primaryNarrativeCount={narrative.primaryCount}
        isPrimary={narrative.isPrimary}
      />
      {/* NOTE: We'll enable this button when we have third party links provided */}
      {/* {isSponsored && (
        <Button variant="primary" href={company.canonicalURL} size="medium">
          Learn about {company.tickerSymbol}
        </Button>
      )} */}
      <NarrativeVoting
        narrativeId={id}
        slug={slug}
        upVotes={voteCount.upvotes}
      />
      <CommentNarrative
        commentKey={narrative.commentKey}
        onCommentClick={onCommentClick}
      />
      <CreateAnnouncement id={id} slug={slug} />
    </div>
  );
};
